import { Stack } from 'react-bootstrap';
import ActivityCard from '../../Features/Activity/ActivityCard';
import ProductCard from '../../Features/Product/Cards/ProductCard';
import DocumentsCard from '../../Features/Documents/Cards/DocumentsCard';
import { LdrNotification } from '../../Features/LoanApp/Cards/LdrNotification';
import NotificationGate from '../Notification/NotificationGate';

export function Dashboard() {
  return (
    <Stack gap={5}>
      <NotificationGate />
      <LdrNotification />
      <ProductCard />
      <ActivityCard />
      <DocumentsCard />
    </Stack>
  );
}

export default Dashboard;
